import React from 'react';
import './style.scss';
import useClientsAddContact from './hooks';
import Button from '../../../../../components/molecules/buttons';
import Form from '../../../../../components/molecules/forms';
import { COM_PREFERENCES, CONTACT_ROLES } from '../../../../../components/atoms/const';

interface Props {
  // eslint-disable-next-line react/require-default-props
  formikClient?: any;
  // eslint-disable-next-line react/require-default-props
  clientContactId?: number | null;
  // eslint-disable-next-line react/require-default-props
  index?: number;
}

function ClientsAddContact(props: Props): React.ReactElement {
  const { formikClient, clientContactId, index } = props;
  const {
    formik, addLoading, currentContactId, updateLoading,
    roleList, rolesLoading, onCancelNavigate,
  } = useClientsAddContact(formikClient, clientContactId);

  const renderForm = () => (
    <div>
      <div className="row">
        <div className="col-lg-4 col-md-6 col-sm-12">
          <Form.Default
            id="firstname"
            placeholder="Enter First Name"
            label="First Name"
            className="mb-4"
            value={formik.values.firstname}
            onChange={formik.handleChange}
            isInvalid={!!formik.errors.firstname && formik.touched.firstname}
            errorMsg={formik.errors.firstname}
            onBlur={formik.handleBlur}
          />
        </div>
        <div className="col-lg-4 col-md-6 col-sm-12">
          <Form.Default
            id="lastname"
            placeholder="Enter Last Name"
            className="mb-4"
            label="Last Name"
            value={formik.values.lastname}
            onChange={formik.handleChange}
            isInvalid={!!formik.errors.lastname && formik.touched.lastname}
            errorMsg={formik.errors.lastname}
            onBlur={formik.handleBlur}
          />
        </div>
        <div className="col-lg-4 col-md-6 col-sm-12">
          <Form.Default
            id="email"
            placeholder="Enter Email Address"
            className="mb-4"
            label="Email Address"
            value={formik.values.email}
            onChange={formik.handleChange}
            isInvalid={!!formik.errors.email && formik.touched.email}
            errorMsg={formik.errors.email}
            onBlur={formik.handleBlur}
          />
        </div>
        <div className="col-lg-4 col-md-6 col-sm-12">
          <Form.Default
            id="phoneNumber"
            placeholder="Enter Phone Number"
            className="mb-4"
            label="Phone Number"
            value={formik.values.phoneNumber}
            onChange={formik.handleChange}
            isInvalid={!!formik.errors.phoneNumber && formik.touched.phoneNumber}
            errorMsg={formik.errors.phoneNumber}
            onBlur={formik.handleBlur}
          />
        </div>
        <div className="col-lg-4 col-md-6 col-sm-12">
          <Form.Default
            id="position"
            placeholder="Enter Position"
            className="mb-4"
            label="Position"
            value={formik.values.position}
            onChange={formik.handleChange}
            isInvalid={!!formik.errors.position && formik.touched.position}
            errorMsg={formik.errors.position}
            onBlur={formik.handleBlur}
          />
        </div>
        <div className="col-lg-4 col-md-6 col-sm-12">
          <Form.ReactSelect.Default
            id="role"
            placeholder="Enter Role"
            label="Role"
            options={CONTACT_ROLES}
            isSearchable={false}
            value={CONTACT_ROLES.find((role) => role.value.toString() === formik.values.role?.toString())}
            onChange={(e) => {
              if (e) formik.setFieldValue('role', e.value);
            }}
            isInvalid={!!formik.errors.role && formik.touched.role}
            errorMsg={formik.errors.role}
            onBlur={formik.handleBlur}
          />
        </div>
        <div className="col-lg-4 col-md-6 col-sm-12">
          <Form.ReactSelect.Default
            id="comPref"
            placeholder="Enter Communication Preference"
            label="Communication Preference"
            options={COM_PREFERENCES}
            isSearchable={false}
            value={COM_PREFERENCES.find((item) => item.value.toString() === formik.values.comPref?.toString())}
            onChange={(e) => {
              if (e) formik.setFieldValue('comPref', e.value);
            }}
            isInvalid={!!formik.errors.comPref && formik.touched.comPref}
            errorMsg={formik.errors.comPref}
            onBlur={formik.handleBlur}
          />
        </div>
      </div>
      <div className={formikClient ? 'd-none' : 'd-flex justify-content-end mt-4 align-self-end'}>
        <div style={clientContactId ? { display: 'none' } : { width: '200px', marginRight: '20px' }}>
          <Button.Default id="cancel" onClick={onCancelNavigate} type="button" label="Cancel" size="lg" outline />
        </div>
        <div style={{ width: '200px' }}>
          <Button.Default
            id="save"
            type="submit"
            label="Save Changes"
            size="lg"
            loading={addLoading || updateLoading}
          />
        </div>
      </div>
    </div>
  );

  return (
    <div className="px-4 px-xl-5">
      <div className={index !== 0 ? 'd-none' : 'fw-bold fz-14 mb-4'} style={{ marginLeft: '20px' }}>
        {`${currentContactId ? 'Edit' : 'Add'} Contact Person`}
      </div>
      {!formikClient ? (<form onSubmit={formik.handleSubmit}>{renderForm()}</form>) : (<div>{renderForm()}</div>)}
    </div>
  );
}
export default ClientsAddContact;
